import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "../src/redux/store";

function handleChunkError(error) {
  if (error.name === "ChunkLoadError") {
    const hasRefreshed = JSON.parse(sessionStorage.getItem("retry-lazy-refreshed") || "false");

    // Retry loading the chunk only once
    if (!hasRefreshed) {
      sessionStorage.setItem("retry-lazy-refreshed", "true");

      // Log detailed error info for chunk loading issues
      console.error("Chunk Load Error: Failed to load chunk.");
      console.error("Chunk URL:", error.request?.url);  // URL of the chunk that failed
      console.error("Error details:", error);  // Full error object

      // Attempt to reload the page to fetch the chunk again
      window.location.reload();
    } else {
      console.error("Chunk Load Error: Retry limit exceeded. Unable to load chunk.");
    }
  } else if (error.message && error.message.includes("Minified React error")) {
    // Handle minified React error
    console.error("Minified React error detected!");
    console.error("Error Code:", error.message);

    // Suggest using the non-minified dev environment for better debugging
    console.warn("For full error details, use the non-minified React build in development.");
    
    // Provide additional helpful information (fallback message)
    console.warn("This error may be related to a chunk load failure or missing assets.");

    // Optionally, you can trigger a reload after logging the error
    // window.location.reload();  // Uncomment to auto-reload after logging the error
  } else {
    // General error handling
    console.error("Unexpected error:", error);
  }
}


const root = ReactDOM.createRoot(document.getElementById("root"));

async function renderApp() {
  try {
    const { default: App } = await import("./App");
    root.render(
      <Provider store={store}>
        <App />
      </Provider>
    );
  } catch (error) {
    handleChunkError(error);
  }
}

renderApp();

if (module.hot) {
  module.hot.accept("./App", () => {
    renderApp();
  });
}

// Reset retry flag on every page load
window.addEventListener("load", () => {
  sessionStorage.removeItem("retry-lazy-refreshed");
});
// Reset retry flag on every page load
window.addEventListener("load", () => {
  sessionStorage.removeItem("retry-lazy-refreshed");

  // ✅ Register service worker
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("✅ Service Worker registered with scope:", registration.scope);
      })
      .catch((error) => {
        console.error("❌ Service Worker registration failed:", error);
      });
  }
});


reportWebVitals();


// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import { Provider } from "react-redux";

// import { store } from "../src/redux/store";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <Provider store={store}>
//     <App />
//   </Provider>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(config.logGeneral && console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
